import React from 'react';
import {classes, style, vars} from './doppe-viewer-spinner.st.css';
import {DoubleRingSpinner, reactCreateMemo} from "@wix/devzai-utils-react";
import type {Values} from "@wix/devzai-utils-common";

export const DoppeViewerSpinnerSize = {
    Custom: 'custom',
    Tiny: 'tiny',
    Small: 'small',
    Medium: 'medium',
    Large: 'large'
} as const;

export type DoppeViewerSpinnerSize = Values<typeof DoppeViewerSpinnerSize>;

export const DoppeViewerSpinner = reactCreateMemo(function DoppeViewerSpinner(props: DoppeViewerSpinner.Props) {
    const {
        size = DoppeViewerSpinnerSize.Medium,
        mainColor,
        secondaryColor,

        className,
        style: inlineStyle,
        ...htmlAttributes
    } = props;

    const customColorStyles = (mainColor !== undefined || secondaryColor !== undefined)
        ? {
            [vars.customMainColor]: mainColor,
            [vars.customSecondaryColor]: secondaryColor,
        }
        : undefined;

    return (
        <DoubleRingSpinner
            {...htmlAttributes}
            className={style(classes.root, {
                size: size ?? undefined,
                customColors: mainColor !== undefined || secondaryColor !== undefined,
            }, className)}
            style={{
                ...inlineStyle,
                ...customColorStyles,
            }}
        />
    );
});

export namespace DoppeViewerSpinner {

    export interface Props extends DoubleRingSpinner.Props {
        size?: DoppeViewerSpinnerSize;
        /**
         * Custom main color for the spinner's primary ring.
         * When provided, overrides the scope-based color.
         */
        mainColor?: string;
        /**
         * Custom secondary color for the spinner's secondary ring.
         * When provided, overrides the scope-based color.
         */
        secondaryColor?: string;
    }
}
